// src/contexts/geral/MessageContext.js
import React, { createContext, useCallback, useContext, useState, useRef } from 'react';
import ModalMessage from '../../components/modal/ModalMessage';

const MessageContext = createContext();

export const useMessage = () => useContext(MessageContext);

export const MessageProvider = ({ children }) => {
    const [showModalMessage, setShowModalMessage] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [alertType, setAlertType] = useState('info');
    const onCloseCallbackRef = useRef(null);

    const showMessage = useCallback((message, type = 'info', onClose = null) => {
        // Implementação da função showMessage
        setModalMessage(message);
        setAlertType(type);
        onCloseCallbackRef.current = onClose;
        setShowModalMessage(true);
    }, []);

    const handleCloseMessage = useCallback(() => {
        setShowModalMessage(false);

        if (onCloseCallbackRef.current) {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);

    return (
        <MessageContext.Provider value={{ showMessage, setShowModalMessage }}>
            {children}
            <ModalMessage show={showModalMessage} message={modalMessage} type={alertType} onClose={handleCloseMessage} />
        </MessageContext.Provider>
    );
};
